<template>
  <LoadScreen v-if="mostrarLoader" />
  <ModalExito v-if="mostrarExito" :mostrarExito="mostrarExito" />
  <ModalError v-if="mostrarError" :mostrarError="mostrarError" />

  <ModalBase v-if="mostrarModal">
    <section class="contenedorPrincipal">
      <section>
        <div class="titulo">{{ tituloHeader }}</div>
        <div class="separador"></div>
      </section>

      <div class="form-group">
        <div class="label">Nombre del Proveedor:</div>
        <input class="inputEditar" type="text" v-model="nombre" placeholder="Ingrese el nombre del proveedor" />
      </div>

      <div class="form-group">
        <div class="label">Selecciona un estado:</div>
        <select class="inputEditar" v-model="estado" @change="cargarCiudades">
          <option value="">-- Seleccione un estado --</option>
          <option v-for="(nombreEstado, index) in estadosNombres" :key="index" :value="nombreEstado">
            {{ nombreEstado }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <div class="label">Selecciona una ciudad:</div>
        <select class="inputEditar" v-model="ciudad" :disabled="!estado">
          <option value="">-- Primero selecciona un estado --</option>
          <option v-for="(item, index) in ciudadesFiltradas" :key="index" :value="item">
            {{ item }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <div class="label">Domicilio:</div>
        <input class="inputEditar" type="text" v-model="domicilio" placeholder="Ingrese el domicilio del proveedor" />
      </div>
      
      <div class="form-group">
        <div class="label">Correo electrónico:</div>
        <input class="inputEditar" type="email" v-model="correo" maxlength="50"
          placeholder="Ingrese un correo electrónico" />
      </div>

      <div class="form-group">
        <div class="label">Teléfono:</div>
        <input class="inputEditar" type="text" v-model="telefono" maxlength="15"
          placeholder="Ingrese un teléfono de contacto" />
      </div>
      
      <section class="contenedorBotones">
        <Button class="btn-regresar" @click="cancelar">Regresar</Button>
        <Button class="btn-guardar" @click="guardarProveedor">Guardar</Button>
      </section>
    </section>
  </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import providerService from "../../services/providerService.js";
import ModalExito from "../Modales/ModalExito.vue";
import ModalError from "../Modales/ModalError.vue";
import LoadScreen from "../Forms/LoadScreen.vue";

// Importar el JSON (Propiedad de Connect & Launch)
import estadosData from '../../data/estados_municipios.json';

export default {
  components: { Button, ModalBase, ModalExito, ModalError, LoadScreen },
  props: {
    tituloHeader: {
      type: String,
      default: "Editar Proveedor",
    },
    proveedor: {
      type: Object,
      required: true,
    },
  },
  data() {
    const initialProveedor = this.proveedor || {};
    const estadosList = estadosData.estados;

    return {
      mostrarLoader: false,
      mostrarModal: true,
      mostrarExito: false,
      mostrarError: false,

      nombre: initialProveedor.Nombre || initialProveedor.nombre || "",
      estado: initialProveedor.Estado || initialProveedor.estado ||"",
      ciudad: initialProveedor.Ciudad || initialProveedor.ciudad ||"",
      domicilio: initialProveedor.Domicilio || initialProveedor.domicilio ||"",
      telefono: initialProveedor.Telefono || initialProveedor.telefono ||"",
      correo: initialProveedor.Correo || initialProveedor.correo ||"",
      estadosList: estadosList, 
      estadosNombres: estadosList.map(e => e.nombre), 
    };
  },
  computed: {
    ciudadesFiltradas() {
      if (!this.estado) return [];

      const estadoObj = this.estadosList.find(e => e.nombre === this.estado);

      return estadoObj ? estadoObj.municipios.map(m=>m.nombre) : [];
    },
  },
  emits: ["cancelar", "actualizar"],
  methods: {
    cancelar() {
      this.$emit("cancelar");
    },
    cargarCiudades() {
      this.ciudad = "";
    },
    async guardarProveedor() {
      this.mostrarLoader = true;
      if (!this.nombre || !this.estado || !this.ciudad || !this.domicilio || !this.correo || !this.telefono) {
        this.mostrarLoader = false;
        this.mostrarModal = false;
        this.mostrarError = true;
        setTimeout(() => this.mostrarError = false, 2000);
        return;
      }

      const proveedorData = {
        Nombre:    this.nombre,
        Estado:    this.estado,    
        Ciudad:    this.ciudad,    
        Domicilio: this.domicilio,
        Telefono:  this.telefono,
        Correo:    this.correo,
      };

      try {
        const idParaEditar = this.proveedor.id_proveedor;

        const response = await providerService.updateProvider(idParaEditar, proveedorData);

        console.log("Proveedor actualizado con éxito", response);
        this.mostrarLoader = false;
        this.mostrarExito = true;

        this.$emit("actualizar", response.data);

        setTimeout(() => {
          this.mostrarExito = false;
          this.$emit("cancelar");
        }, 2000);

      } catch (error) {
        console.error("Error al actualizar el proveedor:", error);
        this.mostrarLoader = false;
        this.mostrarError = true;
        setTimeout(() => (this.mostrarError = false), 2000);
      }
    },
  },
  watch: {
    proveedor: {
      immediate: true,
      handler(nuevo) {
        if (nuevo) {
        this.nombre    = nuevo.Nombre    || "";
        this.estado    = nuevo.Estado    || "";
        this.ciudad    = nuevo.Ciudad    || "";
        this.domicilio = nuevo.Domicilio || "";
        this.telefono  = nuevo.Telefono  || "";
        this.correo    = nuevo.Correo    || "";
        }
      },
    },
  },
};
</script>

<style scoped>
.contenedorPrincipal {
  margin: 0px 30px;
  padding-bottom: 20px;
}

.titulo {
  padding: 30px 0px 10px 0px;
  font-size: 28px;
  font-weight: 600;
  color: #333;
  word-wrap: break-word;
  margin: 0px 30px;
}

.separador {
  border-top: 3px solid #2a428c;
  height: 2px;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 25px;
  opacity: 0.9;
}

.form-group {
  margin-bottom: 15px;
}

.label {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 14px;
  color: #444;
}

.inputEditar {
  width: 100%;
  max-width: 350px;
  height: 38px;
  background-color: #fff;
  border: 1px solid #cbd5e1;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 0px 10px;
  font-size: 14px;
  color: #333;
  outline: none;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.inputEditar:focus {
  outline: none;
  border-color: #29b9f6;
  box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.contenedorBotones {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  margin-top: 35px;
  width: 100%;
}

@media (max-width: 768px) {
  .contenedorPrincipal {
    margin: 0px 15px;
  }

  .titulo {
    font-size: 22px;
    padding-top: 20px;
    text-align: left;
    margin: 0px;
  }

  .separador {
    margin-bottom: 20px;
  }

  .label {
    font-size: 15px;
    margin-top: 10px;
  }

  .inputEditar {
    max-width: 100%;
    height: 42px;
    font-size: 16px;
    padding: 0px 12px;
  }

  .contenedorBotones {
    margin-top: 25px;
    gap: 15px;
  }
}
</style>